import React from "react";
import util from "../../../lib/util";
import { PTO_LEGEND_WEIGHT } from "../pto-consts";

class LegendTile extends React.Component {
    constructor(props) {
        super(props);

        const lighter = util.pSBC(PTO_LEGEND_WEIGHT.Lighter, this.props.color);
        const border = util.pSBC(PTO_LEGEND_WEIGHT.DarkerBorder, this.props.color);

        this.state = {
            lighter,            
            border
        }
    }

    render() {
        return (
            <div className="ap-horiz-margin-5" style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ border: `1px solid ${this.state.border}`, flexGrow: 0, display: "flex", flexDirection: "row" }}>
                    <div dangerouslySetInnerHTML={{ __html: "&nbsp;" }} style={{ width: 5, backgroundColor: this.props.color }}></div>
                    <div dangerouslySetInnerHTML={{ __html: "&nbsp;" }} style={{ width: 10, backgroundColor: this.state.lighter }}></div>
                </div>
                <div className="ap-horiz-margin-5 ap-unwrap-content">{this.props.text}</div>
            </div>
        );
    }
}

export default class PtoCalendarViewLegend extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {       
        return (
            <div className="ap-calendar-view-legend ap-horiz-margin-5">
                {
                    (this.props.items || []).map(item => (<LegendTile key={item.text} color={item.color} text={item.text} />))
                }
            </div>
        );
    }
}